// src/store.js
import createStore from 'react-auth-kit/createStore';
import createRefresh from 'react-auth-kit/createRefresh';
import axios from 'axios';

const refresh = createRefresh({
  interval: 1000, // The time in sec to refresh the Access token,
  refreshApiCallback: async (param) => {
    try {

      
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/auth/token`, param, {
        headers: {'Authorization': `Bearer ${param.authToken}`}
      })
      return {
        isSuccess: true,
        newAuthToken: response.data.token,
        newAuthTokenExpireIn: 1000,
        newRefreshTokenExpiresIn: 600000
      }
    }
    catch(error){
      console.error(error)
      return {
        isSuccess: false
      } 
    }
  }
})

const store = createStore({
  authName: '_auth',                      // Name of the auth token
  authType: 'localstorage',                     // Type of storage (cookie/localStorage)
  cookieDomain: window.location.hostname, // The domain for storing cookies
  cookieSecure: window.location.protocol === 'https:', // Use secure cookie if the site uses HTTPS
  refresh: refresh

});

export default store;
